export const devices = {
    phoneSm: '(max-width: 30em)', // <--- breakpoint = 480px
    phone: '(max-width: 37.5em)', // <--- breakpoint = 600px
    phoneLg: '(max-width: 42.81em)', // <--- breakpoint = 685px
    tabletPortrait: '(max-width: 53.12em)', // <--- breakpoint = 850px
    tabletLandscape: '(max-width: 64em)', // <--- breakpoint = 1024px
    desktop: '(max-width: 75em)', // <--- breakpoint = 1200px
    desktopLg: '(min-width: 90.06em)' // <--- breakpoint = 1441px
}